import React, { useState } from 'react'
import {
  MenuOutlined,
  UserOutlined,
  LogoutOutlined,
  LockOutlined,
} from '@ant-design/icons'
import { Dropdown, Avatar, Modal, Form, Input, message } from 'antd'
import Logo from '../Assets/logo.png'
import { useNavigate } from 'react-router-dom'
import { AdminChangePasswordApi } from "../API's/AdminApi"
import { toast } from 'react-toastify'
import axios from 'axios'

export default function AdminTopbar({ onMenuClick }) {
  const navigate = useNavigate()

  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false)
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false)
  const [form] = Form.useForm()
  const user = JSON.parse(sessionStorage.getItem('userData') || '{}')
  const username = user.username || 'User'

  // ---------------- MENU CLICK ----------------
  const handleMenuClick = ({ key }) => {
    if (key === 'profile') {
      console.log('Go to profile')
    }

    if (key === 'changePassword') {
      setIsPasswordModalOpen(true)
    }

    if (key === 'logout') {
      setIsLogoutModalOpen(true)
    }
  }

  // ---------------- LOGOUT ----------------
  const handleLogout = () => {
    sessionStorage.clear()
    navigate('/')
  }

  // ---------------- CHANGE PASSWORD ----------------

  const handleChangePassword = async () => {
    try {
      const values = await form.validateFields()

      const payload = {
        username: username,
        oldPassword: values.oldPassword,
        newPassword: values.newPassword,
      }

      const res = await axios.put(AdminChangePasswordApi, payload)

      // Handle response
      if (res.data === 'UPDATED') {
        toast.success('Password changed successfully')
        setIsPasswordModalOpen(false)
        form.resetFields()
      } else if (res.data === 'NOTFOUND') {
        toast.error('Old password is incorrect')
      } else {
        toast.error('Something went wrong')
      }
    } catch (error) {
      console.log('Error:', error)
      toast.error('Failed to change password')
    }
  }

  const menuItems = [
    {
      key: 'profile',
      label: username,
      icon: <UserOutlined />,
    },
    {
      key: 'changePassword',
      label: 'Change Password',
      icon: <LockOutlined />,
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: 'Logout',
      icon: <LogoutOutlined />,
      danger: true,
    },
  ]

  return (
    <header className="topbar1">
      {/* LEFT MENU BUTTON */}
      <button
        className="topbar-icon-btn topbar-menu-btn"
        onClick={onMenuClick}
        style={{ border: 'none' }}
      >
        <MenuOutlined style={{ fontSize: 18 }} />
      </button>

      {/* BRAND */}
      <div className="topbar-brand1">
        <img src={Logo} alt="Logo" className="brand-logo1" />

        <div className="brand-text1">
          <span className="brand-name1 pt-1">
            <b> THE ROTARY SILVER JUBILEE TRUST, SWIMMING POOL, SANGLI.</b>
          </span>
          <span className="brand-subname1 pt-1">
            {/* SWIMMING POOL, SANGLI */}
          </span>
        </div>
      </div>

      {/* RIGHT USER DROPDOWN */}
      <div className="topbar-right">
        <Dropdown
          menu={{ items: menuItems, onClick: handleMenuClick }}
          placement="bottomRight"
          trigger={['click']}
        >
          {/* <div className="user-profile">
            <Avatar
              icon={<UserOutlined />}
              style={{ backgroundColor: '#020861', cursor: 'pointer' }}
            />
          </div> */}

          <div
            className="user-profile"
            style={{ display: 'flex', alignItems: 'center', gap: 8 }}
          >
            <span style={{ fontWeight: 500 }}>{username}</span>

            <Avatar
              icon={<UserOutlined />}
              style={{ backgroundColor: '#020861', cursor: 'pointer' }}
            />
          </div>
        </Dropdown>
      </div>

      {/* ---------------- LOGOUT MODAL ---------------- */}
      <Modal
        title="Confirm Logout"
        open={isLogoutModalOpen}
        onOk={handleLogout}
        onCancel={() => setIsLogoutModalOpen(false)}
        okText="Yes, Logout"
        cancelText="Cancel"
        okButtonProps={{ danger: true }}
        centered
      >
        <p>Are you sure you want to logout?</p>
      </Modal>

      {/* ---------------- CHANGE PASSWORD MODAL ---------------- */}
      <Modal
        title="Change Password"
        open={isPasswordModalOpen}
        onOk={handleChangePassword}
        onCancel={() => {
          setIsPasswordModalOpen(false)
          form.resetFields()
        }}
        okText="Update Password"
        centered
        okButtonProps={{
          disabled:
            !form.isFieldsTouched(true) ||
            form.getFieldsError().some(({ errors }) => errors.length),
        }}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="Old Password"
            name="oldPassword"
            rules={[{ required: true, message: 'Please enter old password' }]}
          >
            <Input.Password placeholder="Enter old password" />
          </Form.Item>

          <Form.Item
            label="New Password"
            name="newPassword"
            rules={[
              { required: true, message: 'Please enter new password' },
              { min: 6, message: 'Password must be at least 6 characters' },
            ]}
          >
            <Input.Password placeholder="Enter new password" />
          </Form.Item>

          <Form.Item
            label="Confirm Password"
            name="confirmPassword"
            dependencies={['newPassword']}
            rules={[
              { required: true, message: 'Please confirm password' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve()
                  }
                  return Promise.reject(new Error('Passwords do not match'))
                },
              }),
            ]}
          >
            <Input.Password placeholder="Re-enter new password" />
          </Form.Item>
        </Form>
      </Modal>
    </header>
  )
}
